import * as React from 'react'
import {Button} from '@frontrow/console/src/components/button'

import * as style from './district-search-button.module.scss'

type Props = {
  districtIdInputValue: string
  onInputChange: (e: React.ChangeEvent) => void
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  isFetching?: boolean
}

export default function DistrictSearchInputButton(props: Props): React.ReactElement {
  const {districtIdInputValue, onInputChange, onSubmit, isFetching = false} = props

  const isInvalidInput =
    districtIdInputValue.length > 0 &&
    isNaN(
      typeof districtIdInputValue === 'string'
        ? Number.parseFloat(districtIdInputValue)
        : districtIdInputValue
    )

  return (
    <form className={style.formInline} onSubmit={onSubmit}>
      <div className={style.formGroup}>
        <input
          id="enterDistrictId"
          type="text"
          placeholder="District ID"
          value={districtIdInputValue}
          onChange={onInputChange}
          disabled={isFetching}
          className={style.formInput}
        />{' '}
      </div>
      <Button
        type="submit"
        disabled={isFetching === true || districtIdInputValue.length === 0 || isInvalidInput}
        addClass={style.districtSearchButton}
      >
        {isFetching === true ? 'Searching...' : 'Search'}
      </Button>
    </form>
  )
}
